import { render } from "./BigButton.vue?vue&type=template&id=38513e02"
import script from "./BigButton.vue?vue&type=script&lang=js"
export * from "./BigButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__